import React, { useEffect, useState } from "react";
import Wrapper from "../../components/Common/Wrapper";
import { Col, Row } from "react-bootstrap";
import Product from "../../components/Product";
import Axios from "axios";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ShareModal from "../../components/Common/ShareModal";

const MyPromotion = () => {
  const userLogin = useSelector((state) => state.userLogin);
  const params = useParams();
  const vendorId = params?.vendorId;

  const [data, setData] = useState([]);
  const { userInfo } = userLogin;
  const [show, setShow] = useState(false);
  const [id, setId] = useState("");

  const getPromotedProduct = async () => {
    let config = {
      headers: {
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };
    const response = await Axios.get(
      `/api/promoters/promoted-products?id=${
        vendorId ? vendorId : userInfo?._id
      }`,
      config
    );
    setData(response?.data);
  };

  useEffect(() => {
    getPromotedProduct();
  }, [vendorId, userInfo?._id]);

  const promotedProduct = Array.isArray(data?.data)
    ? data.data.filter((s) => s._id === id)
    : [];

  const promoterCommission =
    promotedProduct && promotedProduct[0]?.promoterCommission;

  return (
    <div>
      <Wrapper>
        <Col
          md={12}
          lg={false ? 12 : 9}
          xl={false ? 12 : 9}
          // lg={userInfo?.isAdminLogin === true ? 12 : 9}
          // xl={userInfo?.isAdminLogin === true ? 12 : 9}
        >
          <div className="paymentMethod-main" style={{ margin: "40px" }}>
            <Row className="align-items-center">
              <Col>
                <h4 className="heading">My Promotions</h4>
              </Col>
            </Row>

            <div className="products products-grid mgs-products">
              <div className="mgs-productsWraper">
                <Row>
                  {data?.data?.map((product) => {
                    return (
                      <Col
                        key={product._id}
                        className="col-xl-4 col-lg-6 col-md-6 col-sm-12"
                      >
                        <Product
                          vendorId={vendorId}
                          userInfo={userInfo}
                          product={product}
                          vendor={true}
                          isPromotion={true}
                          setId={() => setId(product?._id)}
                          isDanzfloMerch={true}
                          openModal={() => setShow(true)}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </div>
          </div>
        </Col>
      </Wrapper>
      {show && (
        <ShareModal
          id={id}
          isPromoter={userInfo?.isPromoter}
          promoterCommission={promoterCommission}
          setShow={setShow}
          show={show}
          setId={setId}
        />
      )}
    </div>
  );
};

export default MyPromotion;
